
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M44.845 21.395h-7.057v21.98h2.544a6.974 6.974 0 007.073 7.114 7.063 7.063 0 007.073-7.052c0-.118-.019-.275-.027-.4a3.005 3.005 0 001.55-2.638v-7.835a11.154 11.154 0 00-11.156-11.169zm-3.917 3.14h3.76a8.227 8.227 0 018.181 8.343H40.928zm6.476 21.814a3.017 3.017 0 113.017-3.017 3.087 3.087 0 01-3.017 3.013zm7.049-3.361M19.432 24.436a11.384 11.384 0 10-8.052 3.336 11.4 11.4 0 008.052-3.336zM9.08 10.581a2.11 2.11 0 014.217 0v4.971l3.786 3.816a2.013 2.013 0 01-1.417 3.451 2.268 2.268 0 01-1.55-.6l-5.035-5z"}}),_c('path',{attrs:{"d":"M31.209 15.205h-4.458A15.572 15.572 0 0122.3 27.377a15.008 15.008 0 01-10.789 4.487 12.815 12.815 0 01-3.956-.6v7.631c0 2.409 1.132 4.262 3.436 4.418 0 .047-.011.093-.011.14a7.071 7.071 0 0014.142.022.887.887 0 00-.007-.1h9V18.131a2.646 2.646 0 00-2.906-2.926zm-10.143 28.25a3.017 3.017 0 11-6.034 0c0-.042 0-.083.006-.125a3.013 3.013 0 016.021 0c.002.044.007.085.007.125z"}})])])
          )
        }
      }
    